import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import DecisionApproved from './DecisionApproved';
import DecisionDeclined from './DecisionDeclined';
import { APPLICATION_RESPONSE } from '../../USConstants';
import { connect } from 'react-redux';
import { ACTOR, CREDIT_TYPE, FLOW_TYPE } from '../../../framework/App/AppConstants';
import { CONTEXT_TYPE } from '../../../framework/App/SkeletonPage/SkeletonPageConstants';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import { triggerEnsightenEvent } from '../../../framework/store/Ensighten/EnsightenActions';
import { ENSIGHTEN_APP_APPROVED, ENSIGHTEN_APP_DECLINED } from '../../../framework/store/Ensighten/EnsightenConstants';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { PYMT_SECURITY_PAGE, PYMT_SECURITY_CARD } from '../PaymentSecurityPage/PaymentSecurityPageConstants';
import './DecisionPage.less';

export class DecisionPage extends Component {
    static propTypes = {
        _csrf: PropTypes.string,
        flow: PropTypes.oneOf(Object.values(FLOW_TYPE)),
        actor: PropTypes.oneOf(Object.values(ACTOR)),
        creditType: PropTypes.string.isRequired,
        financingDetails: PropTypes.object,
        creditLine: PropTypes.object,
        applyType: PropTypes.string.isRequired,
        merchantName: PropTypes.string,
        applicationStatus: PropTypes.string.isRequired,
        applicationResponse: PropTypes.string.isRequired,
        creditIncentiveOutcome: PropTypes.string,
        isBAWithoutPurchase: PropTypes.bool,
        incentivesDetails: PropTypes.object,
        isLinkApplicationFlow: PropTypes.bool,
        isMiniBrowser: PropTypes.bool,
        isMobile: PropTypes.bool,
        isTeslaFlow: PropTypes.bool,
        onComponentDidMount: PropTypes.func.isRequired,
        userFirstName: PropTypes.string,
        messages: PropTypes.object.isRequired,
        showPaymentSecurityMessage: PropTypes.bool
    };
    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount(this.props);
    }

    render() {
        const { applicationResponse, flow, isTeslaFlow } = this.props;
        const decisionApproved = <DecisionApproved {...this.props} />;
        const decisionDeclined = <DecisionDeclined {...this.props} />;
        return (
            <div className="outerWrapper us-wrapper">
                <div id="wrapper">
                    <div id="main">
                        <div id="DecisionPage">
                            {!isTeslaFlow && (
                                <Header
                                    singleColumnLayout={true}
                                    displayLogout={(flow === FLOW_TYPE.DIRECT_APP)}
                                    showXbutton={false}
                                />
                            )}
                            <div id="content">
                                <div className="sticky-container">
                                    <div className="decisionPage">
                                        {applicationResponse === APPLICATION_RESPONSE.APPROVED ? decisionApproved : decisionDeclined }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer showCancelUrl={false} />
            </div>
        );
    }
}

export const mapStateToProps = state => {
    const hasPaymentSecurity = _.get(state, 'serverData.enrollPymtSecurity', false);
    const pymtSecurityExperiment = _.get(state, 'serverData.elmo.PaymentSecurity');
    const showPaymentSecurityMessage = hasPaymentSecurity && (pymtSecurityExperiment === PYMT_SECURITY_PAGE || pymtSecurityExperiment === PYMT_SECURITY_CARD);
    
    return {
        _csrf: state.serverData._csrf,
        flow: state.serverData.flow,
        actor: state.serverData.actor,
        financingDetails: state.serverData.financingDetails || {},
        creditType: _.get(state, 'serverData.financingDetails.credit_type', CREDIT_TYPE.CORE),
        creditLine: _.get(state, 'serverData.decisionModel.credit_line', {}),
        applyType: state.serverData.applyType,
        merchantName: state.serverData.merchantName,
        applicationStatus: _.get(state, 'serverData.decisionModel.applicationStatus', 'unknown'),
        applicationResponse: _.get(state, 'serverData.decisionModel.applicationResponse', 'unknown'),
        creditIncentiveOutcome: _.get(state, 'serverData.decisionModel.creditIncentiveOutcome', ''),
        isBAWithoutPurchase: _.get(state, 'serverData.isBAWithoutPurchase', false),
        incentivesDetails: _.get(state, 'serverData.incentivesDetails', {}),
        isLinkApplicationFlow: _.get(state, 'serverData.decisionModel.linkApplicationFlow', false),
        isMiniBrowser: !!(_.get(state, 'serverData.contextType', '') === CONTEXT_TYPE.MB_CONTEXT),
        isMobile: _.get(state, 'serverData.isMobile', false),
        isTeslaFlow: _.get(state, 'serverData.flow') === FLOW_TYPE.TESLA,
        userFirstName: _.get(state, 'serverData.decisionModel.userFirstName', ''),
        messages: _.get(state, 'serverData.messages'),
        showPaymentSecurityMessage,
    };
};

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount(props) {
        const { applicationResponse, applicationStatus } = props;
        dispatch(trackTransition('pp_credit_decision', 'prepare_pp_credit_decision', { ppc_status: applicationStatus }));
        if (applicationResponse === APPLICATION_RESPONSE.APPROVED) {
            dispatch(triggerEnsightenEvent(ENSIGHTEN_APP_APPROVED));
        } else {
            dispatch(triggerEnsightenEvent(ENSIGHTEN_APP_DECLINED));
        }
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(DecisionPage);
